import { render, staticRenderFns } from "./geral.vue?vue&type=template&id=4bae2ba2&"
import script from "./geral.vue?vue&type=script&lang=js&"
export * from "./geral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports